import { render, staticRenderFns } from "./configurationSettings.vue?vue&type=template&id=b719cf4a&scoped=true"
import script from "./configurationSettings.vue?vue&type=script&lang=js"
export * from "./configurationSettings.vue?vue&type=script&lang=js"
import style0 from "./configurationSettings.vue?vue&type=style&index=0&id=b719cf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b719cf4a",
  null
  
)

export default component.exports